export const educationData = [
    {
        id: 1,
        institution: 'Sarat Rout High School',
        course: 'Board of Seconday Education',
        startYear: '2003',
        endYear: '2013'
    },
    {
        id: 2,
        institution: 'Kalinga Xavier College of Science & Commerce',
        course: 'Council of Higher Secondary Education',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 3,
        institution: 'Centurion University',
        course: 'Bachelor of Technology in CSE',
        startYear: '2015',
        endYear: '2019'
    },
]